/**
 * Function to format number into IDR currency
 * @param {Number} number  
 * @returns {String} formated currency number
 */
export const formatIDR = (number) => new Intl.NumberFormat('id-ID',
  {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }
).format(number);